import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, map } from 'rxjs';
import Swal from 'sweetalert2';
import { logoutResponse } from 'src/app/models/logoutResponse';
import { LoginBody } from '../const/loginBody';
import { signUpBody } from 'src/app/models/signUpBody';
import { messageResponse } from 'src/app/models/messageResponse';
import {
  ForgotPayload,
  OtpBody,
  OtpResendBody,
  OtpResponse,
  ResetPasswordPayload,
  changePassword
} from 'src/app/models/password';
import { CommonResponse } from 'src/app/models/commonResponse';
import { PhoneFormat } from 'src/app/models/phone';
import { VerifyEmailPhone } from '../const/VerifyEmailOrPhone';
import { LoginDetails } from 'src/app/models/login';
import { DocumentResponse } from 'src/app/models/documentResponse';
import { setUpProfile } from 'src/app/models/setUpProfileBody';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  FCMtoken: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    null
  );
  emailSubject: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  profileDetails: BehaviorSubject<LoginDetails | null> =
    new BehaviorSubject<LoginDetails | null>(null);

  resetPhoneSubject: BehaviorSubject<PhoneFormat | null> =
    new BehaviorSubject<PhoneFormat | null>(null);

  resetToken: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();

  docsData = {
    name: '',
    issueDate: '',
    issueDateRequire: false,
    expiryDate: '',
    expiryDateRequire: false,
    key: [
      {
        title: 'first image',
        image: '',
        required: false
      },
      {
        title: 'second image',
        image: '',
        required: false
      }
    ]
  };

  constructor(
    private readonly http: HttpClient,
    private _translateService: TranslateService
  ) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginVendor(loginDetails: LoginBody): Observable<LoginDetails> {
    return this.http
      .post<{
        data: LoginDetails;
      }>(`${environment.base_url}/vendor/login`, loginDetails)
      .pipe(map(res => res.data));
  }

  getProfile(): Observable<LoginDetails> {
    return this.http
      .get<{ data: LoginDetails }>(`${environment.base_url}/vendor/getProfile`)
      .pipe(map(res => res.data));
  }

  forgotPassword(payload: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}/vendor/forgotPassword`,
      payload
    );
  }

  verifyOtp(otp: OtpBody): Observable<OtpResponse> {
    return this.http.post<OtpResponse>(
      `${environment.base_url}/vendor/verifyOtp`,
      otp
    );
  }

  signUpVendor(payload: signUpBody): Observable<messageResponse> {
    return this.http.post<messageResponse>(
      `${environment.base_url}/vendor/signup`,
      payload
    );
  }

  resetPassword(payload: ResetPasswordPayload): Observable<messageResponse> {
    return this.http.post<messageResponse>(
      `${environment.base_url}/vendor/resetPassword`,
      payload
    );
  }

  updateProfile(
    payload: setUpProfile | { isAvailable: boolean }
  ): Observable<LoginDetails> {
    return this.http
      .put<{
        data: LoginDetails;
      }>(`${environment.base_url}/vendor/updateProfile`, payload)
      .pipe(map(res => res.data));
  }

  changePassword(data: changePassword): Observable<changePassword> {
    return this.http.post<changePassword>(
      `${environment.base_url}/vendor/changePassword`,
      data
    );
  }

  logout(): Observable<logoutResponse> {
    return this.http.get<logoutResponse>(
      `${environment.base_url}/vendor/logout`
    );
  }

  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logoutAlert(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('AreYouSure'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this._translateService.instant('Cancel'),
        confirmButtonColor: '#f3e00b',
        cancelButtonColor: '#000',
        confirmButtonText: this._translateService.instant('Logout')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  private drawerOpen = false;
  getDrawerOpen(): boolean {
    return this.drawerOpen;
  }

  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }

  getVendorDocsFromAdmin(): Observable<DocumentResponse> {
    return this.http.get<DocumentResponse>(
      `${environment.base_url}/vendor/requiredDocument`
    );
  }

  verifyMailOrPhoneOtp(payload: VerifyEmailPhone): Observable<LoginDetails> {
    return this.http
      .post<{
        data: LoginDetails;
      }>(`${environment.base_url}/vendor/verifyValidate`, payload)
      .pipe(map(res => res.data));
  }

  verifyEmailOrPhone(payload: ForgotPayload): Observable<LoginDetails> {
    return this.http
      .post<{
        data: LoginDetails;
      }>(`${environment.base_url}/vendor/validateAccount`, payload)
      .pipe(map(res => res.data));
  }

  resendOtp(payload: OtpResendBody): Observable<OtpResponse> {
    return this.http.post<OtpResponse>(
      `${environment.base_url}/vendor/reSendOtpToEmail`,
      payload
    );
  }
}
